import React from 'react';
import { Repeat, DollarSign } from 'lucide-react';

const TradeInSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Safe number parsing function
  const safeParseFloat = (value) => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  // Safely calculate loan amount
  const calculateLoanAmount = () => {
    try {
      const carPrice = safeParseFloat(formData.carPrice);
      const downPayment = safeParseFloat(formData.downPayment);
      const tradeInValue = safeParseFloat(formData.tradeInValue);
      
      const amount = Math.max(0, carPrice - downPayment - tradeInValue);
      
      // Format only if we have a valid number
      return new Intl.NumberFormat('ru-RU', { 
        style: 'currency', 
        currency: 'RUB', 
        maximumFractionDigits: 0 
      }).format(amount);
    } catch (error) {
      // If any error occurs during formatting, return a safe fallback
      return "0 ₽";
    }
  };

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Repeat className="w-5 h-5 mr-2 text-blue-500" />
        Trade-In
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Стоимость автомобиля для Trade-In */}
        <div className="col-span-full md:col-span-1">
          <label htmlFor="tradeInValue" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-2 text-blue-500" />
            Стоимость вашего автомобиля
          </label>
          <input
            type="text"
            id="tradeInValue"
            name="tradeInValue"
            value={formData.tradeInValue}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tradeInValue ? 'input-error' : ''}`}
            placeholder="Введите стоимость"
          />
          {errors.tradeInValue && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tradeInValue}
            </p>
          )}
        </div>
      </div>

      {/* Информационный блок о Trade-In */}
      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Repeat className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Как работает Trade-In
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Trade-In позволяет зачесть стоимость вашего текущего автомобиля в счет оплаты нового. 
              Этот вариант удобен, если вы не хотите самостоятельно продавать автомобиль. 
              Обратите внимание, что оценка по Trade-In обычно на 5-15% ниже рыночной стоимости.
            </p>
            <div className="mt-2 text-xs text-blue-700 dark:text-blue-300">
              <span className="font-medium">Сумма кредита с учетом Trade-In: </span>
              <span className="font-bold">
                {calculateLoanAmount()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradeInSection;